import { h, Component } from 'preact';
import { route } from 'preact-router';

export default class Back extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div class={this.props.class} style={{cursor: "pointer", alignSelf: "flex-start"}} onClick={() => this.props.callback()}>
                <p><span>🔙</span>{this.props.cta}</p>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./components/back/index.js